/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * PDF/PPT/DOCファイルアップロード成功時のレスポンスデータ
 * @export
 * @interface PostPressReleaseDocumentFileSuccessResponseData
 */
export interface PostPressReleaseDocumentFileSuccessResponseData {
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof PostPressReleaseDocumentFileSuccessResponseData
     */
    documentFileName: string;
}

export function PostPressReleaseDocumentFileSuccessResponseDataFromJSON(json: any): PostPressReleaseDocumentFileSuccessResponseData {
    return PostPressReleaseDocumentFileSuccessResponseDataFromJSONTyped(json, false);
}

export function PostPressReleaseDocumentFileSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseDocumentFileSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentFileName': json['document_file_name'],
    };
}

export function PostPressReleaseDocumentFileSuccessResponseDataToJSON(value?: PostPressReleaseDocumentFileSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_file_name': value.documentFileName,
    };
}

